<template>
  <v-app>
    <notifications position="top center" />

    <RouterView />
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
html {
  overscroll-behavior-y: contain;
}

.img-container {
  .v-input {
    .v-input__control {
      .v-input__slot {
        padding: 0 6px !important;
        label {
          left: 5px !important;
        }
        input {
          text-align: center;
        }
      }
    }
  }
}

.v-input {
  .v-input__control {
    .v-input__slot {
      height: 35px;
      min-height: auto !important;
      fieldset {
        border-color: #006064;
        transition: all ease-in-out 0.3s;
      }
      .v-text-field__slot {
        label {
          top: 6px;
          &.v-label--active {
            color: #006064 !important;
            transform: translateY(-13px) scale(0.75);
            transition: all ease-in-out 0.3s;
          }
        }
      }
      .v-input__append-inner {
        margin-top: 5px;
        i {
          color: #006064 !important;
        }
      }
    }
  }
  &.v-input--is-label-active {
    .v-input__control {
      .v-input__slot {
        fieldset {
          border-color: #880e4f;
        }
        .v-text-field__slot {
          label {
            &.v-label--active {
              color: #880e4f !important;
            }
          }
        }
        .v-input__append-inner {
          i {
            color: #880e4f !important;
          }
        }
      }
    }
  }
}
.v-textarea {
  .v-input__control {
    .v-input__slot {
      height: auto;
      textarea {
        margin-top: 8px;
      }
    }
  }
}
.v-select,
.v-textarea {
  .v-input__control {
    .v-input__slot {
      &::before {
        border-color: #007e84 !important;
      }
      &::after {
        border-color: #007e84 !important;
      }

      .v-select__slot {
        color: #006064 !important;
        caret-color: #006064 !important;
        .v-label {
          top: 8px;
          &.v-label--active {
            transform: translateY(-15px) scale(0.75);
            color: #929292 !important;
          }
        }
        .v-select__selections {
          padding-top: 5px !important;
          color: #880e4f !important;
        }
      }
    }
  }
  &.v-input--is-label-active {
    .v-input__control {
      .v-input__slot {
        &::before {
          border-color: #880e4f !important;
        }
        &::after {
          border-color: #880e4f !important;
        }

        .v-select__slot {
          color: #880e4f !important;
          caret-color: #880e4f !important;
          .v-select__selections {
            color: #880e4f !important;
          }
        }
        .v-input__append-inner {
          margin-top: 5px;
          i {
            color: #880e4f !important;
          }
        }
      }
    }
  }
}
.v-menu__content {
  .v-list-item--active {
    &::before {
      background-color: #880e4f;
    }
    .v-list-item__title {
      color: #880e4f !important;
    }
  }
}
.v-radio {
  &.v-item--active {
    label.v-label {
      color: #880e4f;
      transition: all ease-in-out 0.3s;
    }
  }
  label.v-label {
    color: #006064;
  }
}

#app {
  * {
    font: {
      size: 13px;
      family: "Roboto", sans-serif !important;
    }
  }
  &.v-application {
    background-color: white;
    .accent--text {
      transition: all ease-in-out 0.3s;
      color: #880e4f !important;
      caret-color: #880e4f !important;
      label {
        transition: all ease-in-out 0.3s;
        color: #880e4f !important;
        caret-color: #880e4f !important;
      }
    }
    .v-input {
      input,
      textarea {
        color: #880e4f !important;
      }
    }
  }
  .v-icon.v-icon {
    font-size: 24px;
  }
  .sm1 {
    flex-basis: calc(100% * 1 / 12 - 15px);
    max-width: calc(100% * 1 / 12 - 15px);
  }
  .sm2 {
    flex-basis: calc(100% * 12 / 2 - 15px);
    max-width: calc(100% * 2 / 12 - 15px);
  }
  .sm3 {
    flex-basis: calc(100% * 12 / 3 - 15px);
    max-width: calc(100% * 3 / 12 - 15px);
  }
  .sm4 {
    flex-basis: calc(100% * 12 / 4 - 15px);
    max-width: calc(100% * 4 / 12 - 15px);
  }
  .sm5 {
    flex-basis: calc(100% * 12 / 5 - 15px);
    max-width: calc(100% * 5 / 12 - 15px);
  }
  .sm6 {
    flex-basis: calc(100% * 12 / 6 - 15px);
    max-width: calc(100% * 6 / 12 - 15px);
  }
  .sm7 {
    flex-basis: calc(100% * 12 / 7 - 15px);
    max-width: calc(100% * 7 / 12 - 15px);
  }
  .sm8 {
    flex-basis: calc(100% * 12 / 8 - 15px);
    max-width: calc(100% * 8 / 12 - 15px);
  }
  .sm9 {
    flex-basis: calc(100% * 12 / 9 - 15px);
    max-width: calc(100% * 9 / 12 - 15px);
  }
  .sm10 {
    flex-basis: calc(100% * 12 / 10 - 15px);
    max-width: calc(100% * 10 / 12 - 15px);
  }
  .sm11 {
    flex-basis: calc(100% * 12 / 11 - 15px);
    max-width: calc(100% * 11 / 12 - 15px);
  }
  .sm12 {
    flex-basis: calc(100% * 12 / 12 - 15px);
    max-width: calc(100% * 12 / 12 - 15px);
  }
}

h2 {
  font: {
    size: 15px;
    weight: bold;
  }
  color: #006064;
}

h3 {
  font: {
    weight: bold;
  }
  color: #006064;
}

h4 {
  font: {
    size: 12px;
    weight: 300;
  }
  color: #006064;
}

hr {
  border: none;
  border-bottom: 1px solid #880e4f;
  width: 100vw;
  margin-left: -57px;
}

// .v-card__actions {
//   & + .v-window {
//     height: calc(100vh - 56px - 86px - 60px);
//     overflow: auto;
//     padding: 0 45px;
//     // display: flex;
//     // justify-content: center;
//     // align-items: center;
//   }
// }

// .v-window__container {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
//   height: 100% !important;
// }

.v-menu__content {
  .accent {
    background-color: #006064 !important;
  }
}

.v-data-table {
  table {
    // border: 1px solid #880e4f;
    * {
      border-color: #880e4f !important;
    }
    thead {
      tr {
        th {
          height: 45px;
          box-shadow: none !important;
        }
      }
    }
    tr {
      > * {
        &:not(:first-child) {
          // border-left: 1px solid #006064;
        }
      }
      &:nth-child(even) {
        background-color: rgba(#841f63, 5%);
      }
      td {
        height: 35px;
        text-align: center !important;
        color: #841f63 !important;
        &:first-child {
          color: #007e84 !important;
          text-transform: uppercase;
          text-align: left !important;
        }
        &:nth-child(2) {
          text-transform: uppercase;
          color: #841f63;
        }
        &.text-start {
          &:not(:first-child) {
            text-align: center !important;
          }
        }
      }
      th {
        height: 35px;
        text-align: center !important;
        color: #841f63 !important;
        &:first-child {
          color: #007e84 !important;
          text-transform: uppercase;
          text-align: left !important;
        }
        &:nth-child(2) {
          text-transform: uppercase;
          color: #841f63;
        }
        &.text-start {
          &:not(:first-child) {
            text-align: center !important;
          }
        }
      }
    }
    tbody {
      tr {
        // border-top: 1px solid #006064;
      }
      td {
        padding: 10px;
        .v-input {
          .v-input__control {
            .v-input__slot {
              height: 35px;
            }
          }
        }
      }
    }
  }
}
.color-select {
  .preview {
    margin-left: 15px;
    width: 35px;
    height: 35px;
    flex-grow: 0;
  }
}

.save-container {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 60px;
  background-color: #006064;
  display: flex;
  justify-content: center;
  width: 100%;
  .v-btn {
    color: white;
    height: 100% !important;
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
    flex: 1;
    &.save {
      background-color: #006064 !important;
    }
    &.cancel {
      background-color: #880e4f !important;
    }
    .v-icon {
      margin-right: 5px;
    }
  }
}

.v-card__actions {
  border-bottom: 1px solid #880e4f;
  padding: 25px 0 20px !important;
  > .v-btn {
    color: rgba(#006064, 0.2);
  }
  .v-item-group {
    position: relative;
    flex: 1;
    display: flex;
    justify-content: space-between;
    .v-btn {
      border: 1px solid #006064;
      color: #006064;
      background-color: white;
      height: 40px;
      width: 40px;
      &.v-btn--active {
        border-color: rgba(#006064, 0.2);
      }
    }
    hr {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(100% - 30px);
      border-color: rgba(#006064, 0.2);
      margin: auto;
    }
  }
}
.input-number {
  > .v-input {
    margin: 0;
    padding: 0;
    justify-content: center;
    align-items: center;
    .v-input__prepend-outer {
      margin: 0;
    }
    .v-input__append-outer {
      margin: 0;
    }
  }

  .v-text-field {
    .v-input__control {
      .v-input__slot {
        &::before {
          border: none !important;
        }
        input {
          text-align: center;
        }
      }
    }
  }
  .v-icon.v-icon {
    font-size: 18px !important;
  }
}
.checkbox-input-container {
  .v-input {
    margin-top: 0;
    .checkbox-input {
      max-width: 80px !important;
    }
  }
}

.soon {
  background-color: #d1d1d1;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: darken(#d1d1d1, 50%);
  }
}

.v-content__wrap {
  padding: 20px;
  height: calc(100vh - 64px);
  width: 100vw;
  overflow-y: auto;
}

.v-card {
  h2 {
    &.modal_quantity {
      font-size: 15px !important;
    }
  }
}

.disabled-backdrop {
  z-index: 10;
  background-color: grey;
  opacity: 0.6;
  width: 100%;
  height: 100%;
  position: absolute;
}

.v-navigation-drawer {
  z-index: 9999 !important;
}
</style>
